import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FooterSection = ({ dealership }) => {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="bg-secondary text-secondary-foreground py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
                <Icon name="Zap" size={24} color="var(--color-primary)" strokeWidth={2.5} />
              </div>
              <span className="text-xl font-heading font-bold">Grid Balance</span>
            </div>
            <p className="text-sm text-secondary-foreground/80 mb-4">
              Energy is the Key - Gemeinsam schaffen wir eine grünere Zukunft durch nachhaltige Energielösungen.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.gridbalance.de"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center hover:bg-primary/20 transition-smooth"
                aria-label="Website besuchen"
              >
                <Icon name="Globe" size={20} color="var(--color-primary)" />
              </a>
              <a
                href="mailto:oliver.wagner@gridbalance.de"
                className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center hover:bg-primary/20 transition-smooth"
                aria-label="E-Mail senden"
              >
                <Icon name="Mail" size={20} color="var(--color-primary)" />
              </a>
              <a
                href="tel:+4915223152476"
                className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center hover:bg-primary/20 transition-smooth"
                aria-label="Anrufen"
              >
                <Icon name="Phone" size={20} color="var(--color-primary)" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Kontakt</h3>
            <div className="space-y-3 text-sm text-secondary-foreground/80">
              <div className="flex items-start gap-2">
                <Icon name="Phone" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <span>+49 152 231 524 76</span>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="Mail" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <span>oliver.wagner@gridbalance.de</span>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="Globe" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <a
                  href="https://www.gridbalance.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-smooth"
                >
                  www.gridbalance.de
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Ihr Partner</h3>
            <div className="space-y-3 text-sm text-secondary-foreground/80">
              <div className="flex items-start gap-2">
                <Icon name="Building2" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <span>{dealership?.name}</span>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="MapPin" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                {dealership?.street && dealership?.postalCode && dealership?.city ? (
                  <span>{dealership?.street}, {dealership?.postalCode} {dealership?.city}</span>
                ) : dealership?.city ? (
                  <span>{dealership?.city}</span>
                ) : null}
              </div>
              {dealership?.website && (
                <div className="flex items-start gap-2">
                  <Icon name="ExternalLink" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                  <a
                    href={dealership?.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary transition-smooth"
                  >
                    Website besuchen
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-foreground/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-secondary-foreground/60">
            <p>© {currentYear} Grid Balance UG. Alle Rechte vorbehalten.</p>
            <div className="flex gap-6">
              <Link to="/impressum" className="hover:text-primary transition-smooth">Impressum</Link>
              <Link to="/privacy-policy" className="hover:text-primary transition-smooth">Datenschutz</Link>
              <Link to="/terms-and-conditions-agb" className="hover:text-primary transition-smooth">AGB</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;